<div
    class="relative flex min-h-screen w-full items-center justify-center p-4 py-8 sm:p-6 lg:p-10"
    style="
        background: linear-gradient(
            180deg,
            #f8fafc 0%,
            #eef1f6 50%,
            #e9eef5 100%
        );
    "
>
    <!-- Centered Max-Width Container in Middle of Screen -->
    <div
        class="mx-auto flex w-full max-w-6xl items-center justify-between gap-8 lg:gap-12 xl:max-w-[96rem] xl:gap-16"
    >
        <!-- Left Hero & Brand Showcase (Desktop) -->
        <div
            class="relative hidden flex-col justify-center space-y-8 lg:flex lg:w-5/12"
        >
            <!-- Hero Content & Copy -->
            <div class="relative z-10 max-w-xl space-y-6">
                <!-- Brand Logo with Rounded White Background -->
                <div>
                    <a
                        routerLink="/"
                        class="inline-flex items-center justify-center rounded-2xl border border-slate-200/90 bg-white p-3 shadow-xs transition-all duration-200 hover:scale-[1.02] hover:border-slate-300 hover:shadow-sm"
                    >
                        <img
                            src="assets/images/cjc.svg"
                            alt="Chakrijibi Club Logo"
                            class="h-11 w-auto object-contain md:h-12"
                        />
                    </a>
                </div>

                <!-- Tag / Badge -->
                <div
                    class="inline-flex items-center gap-2 rounded-full border border-sky-200/80 bg-sky-50 px-3.5 py-1.5 text-xs font-semibold text-[#1587e8] shadow-xs"
                >
                    <ng-icon
                        name="lucideSparkles"
                        class="h-3.5 w-3.5 text-[#1587e8]"
                    />
                    <span>Corporate Benefit Ecosystem</span>
                </div>

                <h1
                    class="font-secondary text-3xl leading-snug font-extrabold tracking-tight text-[#0f172a] sm:text-4xl"
                >
                    Join thousands enjoying <br />
                    <span
                        class="bg-gradient-to-r from-[#0284c7] to-[#0f6ebd] bg-clip-text text-transparent"
                        >corporate privileges</span
                    >
                    every day.
                </h1>

                <p class="text-sm leading-relaxed text-slate-600 sm:text-base">
                    Register with your corporate email address to unlock
                    verified member discounts, digital gift vouchers, and
                    special promotional deals designed exclusively for
                    professionals.
                </p>

                <!-- Feature Highlight Cards (Light theme) -->
                <div class="grid grid-cols-1 gap-3 pt-2 sm:grid-cols-3">
                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-sky-50 text-[#1587e8]"
                        >
                            <ng-icon name="lucideTag" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Curated Brands
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Top national retailers & partners
                        </p>
                    </div>

                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"
                        >
                            <ng-icon name="lucideSparkles" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Daily Rewards
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Fresh weekly deals & vouchers
                        </p>
                    </div>

                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-blue-50 text-blue-600"
                        >
                            <ng-icon name="lucideShieldCheck" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Verified Perks
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Corporate email protected
                        </p>
                    </div>
                </div>
            </div>

            <!-- Trust Footer -->
            <div
                class="flex items-center justify-between border-t border-slate-200/80 pt-5 text-xs text-slate-400"
            >
                <p>&copy; 2026 ChakrijibiClub. All rights reserved.</p>
                <div class="flex items-center gap-1.5 text-slate-500">
                    <ng-icon
                        name="lucideShieldCheck"
                        class="h-4 w-4 text-emerald-600"
                    />
                    <span>256-Bit SSL Encrypted</span>
                </div>
            </div>
        </div>

        <!-- Right Form Section -->
        <div
            class="relative flex w-full flex-col items-center justify-center lg:w-7/12"
        >
            <!-- Mobile Logo Bar -->
            <div class="flex w-full items-center pb-4 lg:hidden">
                <a
                    routerLink="/"
                    class="inline-flex items-center justify-center rounded-xl border border-slate-200/90 bg-white p-2 shadow-xs transition-transform hover:scale-[1.02]"
                >
                    <img
                        src="assets/images/cjc.svg"
                        alt="Chakrijibi Club Logo"
                        class="h-8 w-auto object-contain"
                    />
                </a>
            </div>

            <!-- Centered Register Card with INCREASED WIDTH (max-w-xl) -->
            <div class="mx-auto my-auto w-full max-w-xl py-6">
                <div
                    class="relative overflow-hidden rounded-3xl border border-slate-200/90 bg-white p-8 shadow-xl shadow-slate-200/60 sm:p-10 md:p-12"
                >
                    <!-- Top Accent Line -->
                    <div
                        class="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98]"
                    ></div>

                    <!-- Card Header -->
                    <div class="mb-8 space-y-2 text-left">
                        <h2
                            class="font-secondary text-2xl font-bold tracking-tight text-[#0f172a] sm:text-3xl"
                        >
                            Create an Account
                        </h2>
                        <p class="text-sm text-slate-500">
                            Join your company network and start saving
                            immediately
                        </p>
                    </div>

                    <!-- Error Alert Banner -->
                    @if (errorMessage()) {
                        <div
                            class="mb-6 flex items-start gap-3 rounded-2xl border border-red-200 bg-red-50/90 p-4 text-sm text-red-700 shadow-xs"
                        >
                            <ng-icon
                                name="lucideAlertCircle"
                                class="mt-0.5 h-5 w-5 shrink-0 text-red-600"
                            />
                            <div class="flex-1 leading-relaxed font-medium">
                                {{ errorMessage() }}
                            </div>
                        </div>
                    }

                    <!-- Registration Form Component -->
                    <lib-register-user-form
                        (formSubmit)="onRegisterSubmit($event)"
                        [disabled]="isSubmitting()"
                    ></lib-register-user-form>
                </div>

                <!-- Footer Sign-in Prompt -->
                <p class="mt-8 text-center text-sm text-slate-500">
                    Already have an account?
                    <a
                        routerLink="/login"
                        class="font-semibold text-[#1587e8] transition-colors hover:text-[#0f6ebd] hover:underline"
                    >
                        Sign in to your account
                    </a>
                </p>
            </div>

            <!-- Bottom Security Note -->
            <div class="pt-4 text-center text-xs text-slate-400">
                Protected by corporate SSO and security protocols.
            </div>
        </div>
    </div>
</div>
